
export const delProductsCache = () => {
    localStorage.removeItem("productList");
    localStorage.removeItem("userProducts");
  }